import styled from 'styled-components';

export const StyledPriceLine = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondaryFont};

  .modifier {
    display: flex;
    flex-direction: row;
    font-size: 14px;
    line-height: 28px;
    color: ${({ theme }) => theme.colors.textSecondary};
    padding-bottom: 12px;
  }

  .subtotal {
    display: flex;
    flex-direction: row;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.textSecondary};
    ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular}
  }

  .total {
    display: flex;
    flex-direction: row;
    text-align: left;
    font-size: 1.5em;
    font-weight: 800;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    margin: 0;
    color: ${({ theme }) => theme.colors.textPrimary};
    padding-top: 20px;
  }

  & .format {
    .left {
      padding-right: 8px;
    }

    .right {
      text-align: right;
      flex: auto !important;
      padding-right: 0 !important;
    }
  }

  & .checkout {
    padding-bottom: 0 !important;
  }
`;

export const InfoIcon = styled.img`
  width: 24px;
  height: 24px;
`;
